import PinCodeInput from './PinCodeInput';
export * from './PinCodeInput';
export default PinCodeInput;
